export default "__VITE_ASSET__fb386e39__"